import React, { useEffect } from 'react';
import Rodal from 'rodal';
import { useDispatch, useSelector } from 'react-redux';
import { useImmer } from 'use-immer';
import { useMediaQuery } from 'react-responsive';

import {
  fetchCollectionSeeds,
  refetchCollectionSeeds,
} from 'store/collections/seeds/actions.js';
import Spinner from 'components/common/Spinner';
// import Card from './card';
import Button from 'components/common/Button';
import { NewSeedModalContent, AddSeedFromFileModalContent } from './modals';
import Table from './table';

const SettingsSeedEntitiesPage = (props) => {
  const dimension_1024 = useMediaQuery({ maxWidth: 1024 });

  const dispatch = useDispatch();
  const fetchCollectionSeedsState = useSelector(
    (state) => state.collection.seeds.fetch
  );

  const collectionName = props.match.params.id;

  const [state, setState] = useImmer({
    toggleAddSeed: false,
    addSeedType: '',
    addSeedName: '',
    toggleUploadSeedFile: false,
  });

  useEffect(() => {
    dispatch(fetchCollectionSeeds(collectionName));
  }, []);

  if (fetchCollectionSeedsState.loading) {
    return (
      <div className="mx-4 my-4 px-6 py-10 flex items-center justify-center">
        <Spinner loaderSize="lg" />
      </div>
    );
  }

  const openAddSeedFromFile = () => {
    setState((draft) => {
      draft.toggleUploadSeedFile = true;
      draft.toggleAddSeed = false;
    });
  };

  const onCloseNewSeedModal = () => {
    setState((draft) => {
      draft.toggleAddSeed = false;
    });
  };

  const closeNewSeedModalWithRefresh = () => {
    onCloseNewSeedModal();
    dispatch(refetchCollectionSeeds(collectionName));
  };

  return (
    <div id="collection-settings-seed-entities" className="">
      <div className="text-right">
        <Button
          intent="primary"
          // showSpinner={true}
          type="button"
          extendClass="text-md lg:text-lg"
          onClick={() => {
            setState((draft) => {
              draft.toggleAddSeed = true;
            });
          }}
          // loading={sendUserInviteTeamState.loading ? true : false}
          //   disable={userLoginState.loading ? false : isSubmitting}
        >
          Add seed
        </Button>
      </div>
      <div className="mt-10">
        {fetchCollectionSeedsState?.data?.length ? (
          <Table data={fetchCollectionSeedsState?.data} />
        ) : null}
      </div>

      <Rodal
        className="rodal-seed-entities"
        visible={state.toggleAddSeed}
        onClose={onCloseNewSeedModal}
        customStyles={{
          width: dimension_1024 ? '85%' : '40%',
          height: '350px',
        }}
        closeMaskOnClick={true}
        closeOnEsc={true}
        animationType="enter"
        showCloseButton={false}
      >
        <NewSeedModalContent
          collectionName={collectionName}
          openAddSeedFromFile={openAddSeedFromFile}
          closeNewSeedModal={onCloseNewSeedModal}
          closeNewSeedModalWithRefresh={closeNewSeedModalWithRefresh}
        />
      </Rodal>

      <Rodal
        className="rodal-seed-entities"
        visible={state.toggleUploadSeedFile}
        onClose={() => {
          setState((draft) => {
            draft.toggleUploadSeedFile = false;
          });
        }}
        customStyles={{
          width: dimension_1024 ? '85%' : '45%',
          height: '300px',
        }}
        closeMaskOnClick={true}
        closeOnEsc={true}
        animationType="enter"
        showCloseButton={false}
      >
        <AddSeedFromFileModalContent collectionName={collectionName} />
      </Rodal>
    </div>
  );
};

export default SettingsSeedEntitiesPage;
